import React, { useEffect, useState } from 'react';
import DashboardHeader from "./components/DashboardHeader";
import DashboardCards from "./components/DashboardCards";
import DashboardFilters from "./components/DashboardFilters";
import DashboardTable from "./components/DashboardTable";
import DashboardCharts from "./components/DashboardCharts";
import { getStockProductos, getAlertasStock, getMovimientosProductos } from "../../../services/financiero/finVistasService";

export default function DashboardFinanciero() {

    const [stock, setStock] = useState([]);
    const [alertas, setAlertas] = useState([]);
    const [movimientos, setMovimientos] = useState([]);
    const [viewMode, setViewMode] = useState("charts");
    const [loading, setLoading] = useState(true);
    const [filters, setFilters] = useState({});
    const cargarDashboard = async () => {
        try {

            setLoading(true);
            const [
                stockData,
                alertasData,
                movimientosData
            ] = await Promise.all([
                getStockProductos(),
                getAlertasStock(),
                getMovimientosProductos()
            ]);
            console.log("Stock:", stockData);
            setStock(stockData);
            setAlertas(alertasData);
            setMovimientos(movimientosData);
        } catch (error) {
            console.error("Error cargando dashboard financiero", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        cargarDashboard();
    }, []);
    const handleFilterChange = (key, value) => {
        setFilters(prev => ({
            ...prev,
            [key]: value
        }));
    };
    const resetFilters = () => {
        setFilters({});
    };
    const filteredMovimientos = movimientos.filter(m => {
        if (filters.proyecto && m.proyecto !== filters.proyecto)
            return false;
        if (filters.tipo_entrega && m.tipo_entrega !== filters.tipo_entrega)
            return false;
        if (filters.departamento && m.departamento !== filters.departamento)
            return false;
        if (filters.municipio && m.municipio !== filters.municipio)
            return false;
        if (filters.producto && m.nombre_producto !== filters.producto)
            return false;
        if (filters.fecha && filters.fecha.length === 2) {
            const fecha = new Date(m.fecha_entrega);
            const inicio = filters.fecha[0].startOf("day").toDate();
            const fin = filters.fecha[1].endOf("day").toDate();
            if (fecha < inicio || fecha > fin)
                return false;
        }
        return true;
    });

    return (
        <div className="container">
            <DashboardHeader onRefresh={cargarDashboard} />
            <DashboardFilters
                movimientos={movimientos}
                filters={filters}
                onFilterChange={handleFilterChange}
                onReset={resetFilters}
                viewMode={viewMode}
                setViewMode={setViewMode}
            />
            <DashboardCards
                stock={stock}
                alertas={alertas}
                movimientos={filteredMovimientos}
                loading={loading}
            />
            {viewMode === "charts" && (
                <DashboardCharts
                    stock={stock}
                    movimientos={filteredMovimientos}
                />
            )}
            {viewMode === "table" && (
                <DashboardTable
                    movimientos={filteredMovimientos}
                    stock={stock}
                    alertas={alertas}
                    loading={loading}
                />
            )}
        </div>
    );
}